import { FC, useState } from 'react'
import { Auth as aws } from 'aws-amplify'
import { RenderIf } from 'shared/helpers/renderIf'
import { AdminComponent } from 'widgets/AdminComponent'
import { LoginComponent } from 'entities/LoginComponents/loginComponent'
import { MFACode } from 'entities/LoginComponents/mfaComponent'
import { useAuthStore } from 'shared/store/authSlice'

export const LoginPage: FC = () => {
  const { logIn } = useAuthStore()
  const [authUser, setAuthUser] = useState<{ challengeName: string }>()
  const [mfaRequired, setMfaRequired] = useState<boolean>(false)

  const moveToMFA = (userToSet: { challengeName: string }) => {
    setAuthUser(userToSet)
    setMfaRequired(true)
  }

  const submitMFA = async (mfaCode: string) => {
    if (authUser) {
      const mfaType = authUser.challengeName === 'SOFTWARE_TOKEN_MFA' ? 'SOFTWARE_TOKEN_MFA' : null
      await aws.confirmSignIn(authUser, mfaCode, mfaType)
      logIn()
    }
  }

  return (
    <AdminComponent>
      <RenderIf condition={!mfaRequired}>
        <LoginComponent moveToMFA={moveToMFA} />
      </RenderIf>
      <RenderIf condition={mfaRequired}>
        <MFACode submitMFA={submitMFA} />
      </RenderIf>
    </AdminComponent>
  )
}
